import Fetching from "@/components/Fetching/Fetching";
import { CheckCircle2, CircleX } from "lucide-react";

import classes from "./integration.module.scss";
import IntegrationSyncMessage from "./IntegrationSyncMessage";

const IntegrationDelivery = ({ completeOrder, completeOrderDelivery, hasError = false, messageLines = [], messageOrderDelivery = "" }) => {
	const lines = messageLines.length > 0 ? messageLines : messageOrderDelivery ? [messageOrderDelivery] : [];

	return (
		<div className={`${classes.content} ${completeOrder && !completeOrderDelivery && classes.inProcess} ${completeOrderDelivery && classes.complete}`}>
			<div>
				Obteniendo Guías de Despacho
				<IntegrationSyncMessage messageLines={lines} />
			</div>
			<div>
				{completeOrder && !completeOrderDelivery && <Fetching topMargin={"0px"} />}{" "}
				{completeOrderDelivery && !hasError && <CheckCircle2 className={`${classes.checkIcon} ${classes.successIcon}`} />}
				{completeOrderDelivery && hasError && <CircleX className={`${classes.checkIcon} ${classes.errorIcon}`} />}
			</div>
		</div>
	);
};

export default IntegrationDelivery;
